import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/user-services/auth.service';
import { UserSettingsService } from 'src/app/core/services/user-settings/user-settings.service';
import { UserSettings } from 'src/app/models/user-settings';

@Component({
  selector: 'app-signin-callback',
  template: `
    <div>
    </div>
  `
})
export class SigninCallbackComponent implements OnInit {

  constructor(public authService: AuthService,
              private router: Router) { }

  ngOnInit() {
    this.authService.completeLogin().then(() => {
      this.router.navigate(['/menu/home']);
    });
    // .then(
    //   () => {this.userSettingsService.getNoLoad().subscribe(
    //     res => {
    //       if (res == null) {
    //         const userSettings: UserSettings = {emailOnPersonalEvents: false, emailOnPublicEvents: false, emailOnSubscriptionExpiry: false };
    //         this.userSettingsService.post(userSettings).subscribe();
    //       }
    //     }
    //   ); }
    // );
  }

}
